var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockhistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85059 10.5371C2.34082 10.5371 2.19141 10.8887 2.49023 11.3018L4.40625 14.0352C4.65234 14.3779 4.99512 14.3779 5.23242 14.0352L7.14844 11.3018C7.43848 10.8887 7.28906 10.5371 6.78809 10.5371H5.3291C6.06738 7.06543 9.14355 4.48145 12.8438 4.48145C17.0889 4.48145 20.5166 7.90039 20.5166 12.1543C20.5166 16.3994 17.0889 19.8447 12.8438 19.8271C10.1719 19.8271 7.84277 18.4561 6.47168 16.3994C6.26953 16.127 5.94434 16.0391 5.66309 16.2061C5.39941 16.3643 5.32031 16.7334 5.54004 17.0322C7.18359 19.3613 9.82031 20.9697 12.8438 20.9697C17.6689 20.9697 21.6592 16.9795 21.6592 12.1543C21.6592 7.32031 17.6689 3.33887 12.8438 3.33887C8.56348 3.33887 4.94238 6.46777 4.17773 10.5371H2.85059ZM12.501 7.11816C12.1934 7.11816 11.9561 7.35547 11.9561 7.6543V12.4795C11.9561 12.6641 12.0088 12.8047 12.1318 12.9629L14.3467 15.8896C14.5664 16.1709 14.8916 16.2148 15.1553 16.0215C15.4014 15.8457 15.4277 15.5293 15.2256 15.2656L13.0283 12.3389V7.6543C13.0283 7.35547 12.791 7.11816 12.501 7.11816Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockhistory);
export default __webpack_public_path__ + "static/media/Clock history.db12cdcd35b37c83cc6947cf3c2b0270.svg";
export { ForwardRef as ReactComponent };